import { Expose } from 'class-transformer';
import { SurveyElement } from './element';

export class SurveyButtonElement extends SurveyElement {
  @Expose({ name: 'text' })
  label!: string;

  @Expose()
  action!: number;

  @Expose()
  extra!: {
    tel?: string;
    mailto?: string;
  } | null;

  @Expose()
  outlined!: boolean;
}
